<div fxLayout="row" fxLayoutAlign="start center">
    <div id="lb{{id}}" class="label field-label p-4">{{value}}</div>
</div>
